import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const LabelsContainer = styled.div `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: ${themeGet('spacing.lg')};
`;
export const SwitchFieldContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding: ${themeGet('spacing.md')};
  margin-bottom: ${themeGet('spacing.xl')};
  border-radius: ${themeGet('borderRadius.md')};
  border: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
`;
